import { render, staticRenderFns } from "./TextSizeBoxTool.vue?vue&type=template&id=cd7ddaee&"
import script from "./TextSizeBoxTool.vue?vue&type=script&lang=js&"
export * from "./TextSizeBoxTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports